/** 
 * The primitive types in javascript. `undefined` and `null` data type were not included by purpose. 
 */
export type PrimitiveType = number | string | boolean | bigint | symbol;

/**
 * Infers the underlying primitive type of {@link ValueObject}.
 */
export type ValueObjectPrimitiveType<T> = T extends ValueObject<infer TPrimitive> ? TPrimitive : never;

/**
 * Represents either the {@link ValueObject} specified in {@link TValueObject} or the underlying {@link PrimitiveType}.
 */
export type ValueObjectOrPrimitiveType<TValueObject extends ValueObject<PrimitiveType>> = TValueObject | ValueObjectPrimitiveType<TValueObject>;

export abstract class ValueObject<T extends PrimitiveType> {
  protected constructor(protected readonly value: T) {
    this.validate();
  }

  /** Validates the value object. Called in the constructor. */
  protected abstract validate(): void;

  /** Returns the string representation of the value object. */
  public toString = (): string => typeof this.value === 'string' ? this.value : this.value.toString();

  /** Returns the underlying value of the value object. */
  public valueOf = (): T => this.value;
}